// extracted by mini-css-extract-plugin
export var quantityInput = "_k0-0";